export var EventError = {
    CREATE: 'create',
    UPDATE: 'update',
    FETCH: 'fetch',
};
